import { FontSize } from './font-size';
export * from './font-size';
export default FontSize;
